import { useQuoteWizardQuery } from '@ecomm/lander'
import { usePartnerPageTemplateQuery } from './usePartnerTemplatePageQuery'

export function usePartnersDataQueries(contentful_id: string) {
  const partnerPageData = usePartnerPageTemplateQuery(contentful_id)

  const quoteWizard = useQuoteWizardQuery('6wRdF53o74w2MhOhBIkzip')
  return { partnerPageData, quoteWizard }
}
